// DOM-хуки FAQ. Поведение завязано на data-атрибуты, а не на визуальные классы.
const sectionSelector = '[data-faq-section]';
const itemSelector = '[data-faq-item]';
const triggerSelector = '[data-faq-trigger]';
const panelSelector = '[data-faq-panel]';

// Единственный класс, который отвечает за открытый пункт аккордеона.
const activeItemClassName = 'faq-section__accordion-item--active';

// Синхронизирует визуальное состояние и aria-атрибуты.
const setItemExpanded = (item, isExpanded) => {
    const trigger = item.querySelector(triggerSelector);
    const panel = item.querySelector(panelSelector);

    item.classList.toggle(activeItemClassName, isExpanded);
    trigger?.setAttribute('aria-expanded', String(isExpanded));
    panel?.setAttribute('aria-hidden', String(!isExpanded));
};

// Выделение текста внутри ответа не должно открывать или закрывать пункт.
const hasSelectionInside = (item) => {
    const selection = window.getSelection();

    return Boolean(
        selection
        && !selection.isCollapsed
        && (item.contains(selection.anchorNode) || item.contains(selection.focusNode))
    );
};

// Ссылки и поля внутри ответа должны обрабатывать клик сами.
const shouldSkipToggle = (event, item) => {
    if (hasSelectionInside(item)) {
        return true;
    }

    if (!(event.target instanceof Element)) {
        return false;
    }

    return Boolean(event.target.closest('a[href], button:not([data-faq-trigger]), input, textarea, select, label'));
};

// Инициализирует одну FAQ-секцию через один делегированный обработчик клика.
export const initFaqSection = () => {
    const section = document.querySelector(sectionSelector);

    if (!section) {
        return;
    }

    // Если активный пункт когда-нибудь будет задан в Blade, JS подхватит его.
    let activeItem = section.querySelector('.' + activeItemClassName);

    if (activeItem) {
        setItemExpanded(activeItem, true);
    }

    // Один обработчик на секцию вместо обработчика на каждый пункт.
    section.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        // Клики вне пунктов FAQ игнорируются.
        const item = event.target.closest(itemSelector);

        if (!item || !section.contains(item) || shouldSkipToggle(event, item)) {
            return;
        }

        const shouldOpenItem = item !== activeItem;

        // Одновременно может быть открыт только один пункт.
        if (activeItem) {
            setItemExpanded(activeItem, false);
        }

        // Клик по открытому пункту закрывает его, клик по другому открывает новый.
        setItemExpanded(item, shouldOpenItem);
        activeItem = shouldOpenItem ? item : null;
    });
};
